import React from "react";
import { motion } from "framer-motion";
import { Play, MapPin } from "lucide-react";
import { Reveal } from "./Reveal";
import { useSiteContent } from "../../context/SiteContent";

export const Deployments = ({ onPlay }) => {
  const { content } = useSiteContent();
  const projects = (content?.galleryMedia?.projects || []);

  return (
    <section id="deployments" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <Reveal className="max-w-2xl">
            <p className="overline text-helios-cyan mb-3">Field Deployments</p>
            <h2 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight text-helios-slate leading-[1.05]">
              Watch the robots in the field.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-slate-500 text-sm max-w-xs md:text-right">
              Real footage from live utility parks and industrial rooftops — tap any film to play.
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {projects.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.08}>
              <button onClick={() => onPlay(p)}
                className="card-hover group relative w-full text-left rounded-2xl overflow-hidden border border-helios-line aspect-video"
                data-testid={`deployment-video-${i}`}>
                <img src={p.mediaType === "youtube"
                  ? `https://i.ytimg.com/vi/${(p.mediaUrl || "").match(/[A-Za-z0-9_-]{6,}/)?.[0] || ""}/hqdefault.jpg`
                  : p.mediaUrl}
                  alt={p.title} loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-helios-slate/90 via-helios-slate/25 to-transparent" />
                <div className="absolute top-4 left-4">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-white/90 backdrop-blur px-3 py-1 font-mono text-[10px] uppercase tracking-widest text-helios-slate">
                    <MapPin size={11} /> {p.categoryTag}
                  </span>
                </div>
                <motion.div whileHover={{ scale: 1.08 }} className="absolute inset-0 flex items-center justify-center">
                  <span className="flex items-center justify-center w-16 h-16 rounded-full bg-white/90 backdrop-blur group-hover:bg-helios-cyan transition-colors">
                    <Play size={24} className="fill-helios-slate text-helios-slate group-hover:fill-white group-hover:text-white ml-1 transition-colors" />
                  </span>
                </motion.div>
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="font-display font-semibold text-white leading-snug">{p.title}</p>
                  <p className="font-mono text-[10px] text-slate-300 mt-1">{p.location} · {p.capacity}</p>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
